class IndexRecentlyViewed extends HTMLElement {
    constructor() {
        super();
        this.wrapper = this.querySelector('.js-recently-viewed-wrapper');
        this.splitContainer = this.querySelector('.js-recently-viewed-split-container');
        this.slider = this.querySelector('.recently-viewed-product-slider');
        this.init();
    }

    init() {

        const productTemplateId = 'index-recently-viewed-product-template'
        const wrapperId = this.slider.id;

        const list = Shopify.Products.getList() || [];

        //show section
        if (list.length > 0) {

            if (list.length == 1) {
                this.slider.classList.add('has-only-one-item');

                //also check if the first item is empty string
                if(list[0] == "") return;
            }

            this.show();

        } else {
            return
        }

        Shopify.Products.showRecentlyViewed({
            wrapperId: wrapperId,
            templateId: productTemplateId,
            onComplete: this.loadComplete.bind(this)
        })
    }

    show() {
        this.wrapper.style.display = "block";
    }

    hide(){
        this.wrapper.style.display = "none";
    }

    loadComplete() {
        console.log('slider', this.slider)

        //do final check if there is really an item. If not hide the section
        const items = this.querySelectorAll('.recently-viewed-product-item');
        if(items.length == 0){
            this.hide();
            return;
        }
        
        const flkty = new Flickity(this.slider, {
            cellAlign: 'left',
            contain: true,
            wrapAround: false,
            pageDots: true,
            prevNextButtons: true,
            draggable: true,
            imagesLoaded: true
        });

        this.slider.dataset.flickityInitialized = 'true';
        this.slider.classList.add('flickity-initialized');

        //call parallax after
        //this.parallax();

    }

    parallax(){
        jarallaxElement();
        jarallax(this.container);
        console.log('recent init parallax');
    }
  

}
  
  customElements.define('index-recently-viewed', IndexRecentlyViewed);